import React from 'react'

import classNames from 'classnames'
import { Link, useLocation } from 'react-router-dom'

interface Props {
  selected?: boolean
  label: string
  icon?: React.ElementType
  iconName?: string
  iconSize?: string
  to?: string
  external?: boolean
  onClick?: () => void
  mobile?: boolean
  exact?: boolean
}

const NavItem: React.FC<Props> = ({
  selected,
  label,
  icon: Icon,
  to,
  external,
  onClick,
  mobile,
  iconName,
  iconSize,
  exact,
}: Props) => {
  const { pathname } = useLocation()

  let isHighlighted = selected
  if (selected === undefined && to !== undefined)
    isHighlighted = exact ? pathname === to : pathname.startsWith(to)
  const className = classNames(
    'flex-row items-center px-2 mx-1 desktop:mx-2 border-b-2 cursor-pointer hover:border-b-orange learn:hover:border-b-green',
    isHighlighted ? 'border-b-orange learn:border-b-green' : 'border-b-transparent',
    mobile ? 'flex' : 'hidden md:flex'
  )
  const content = (
    <>
      {Icon && (
        <span className="desktop:mr-1.5 text-gray-icons dark:text-gray flex flex-col items-center">
          <Icon />
        </span>
      )}
      {iconName && (
        <span className="desktop:mr-1.5 text-gray-icons dark:text-gray flex flex-col items-center">
          <i className={classNames('nf-icon', iconName, iconSize ?? 'text-xl')} />
        </span>
      )}
      <span className="hidden text-base font-medium text-black dark:text-gray desktop:block">
        {label}
      </span>
    </>
  )
  if (onClick)
    return (
      <button type="button" className={className} onClick={onClick}>
        {content}
      </button>
    )
  if (external)
    return (
      <a title={label} href={to} className={className}>
        {content}
      </a>
    )
  return (
    <Link to={to ?? '#'} className={className} data-testid={`NavItem-${label}`}>
      {content}
    </Link>
  )
}

export default NavItem
